import './why_choose_section.scss';
import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';
export const WhyChooseUsSection = ({
    fields
}) => {
    return <section id="why-us-section" className="home-section">
        <div className="container">
            <div className='section-header'>
                <h2>{ fields?.why_choose_us_title ?? 'Why Choose Us'}</h2>
            </div>

            <div className='why-us-wrapper'>
                <div className='why-us-repeater'>
                    {
                        fields?.why_choose_repeater?.map((it, index) => <div className='block-item' key={index}>
                            <span className='block-icon' dangerouslySetInnerHTML={{ __html: it.block_icon }}></span>
                            <span className='block-name'>{ it?.block_title }</span>
                            <span className='block-details'>{ it?.block_details }</span>
                        </div>)
                    }
                </div>
            </div>
        </div>
    </section>
}